// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  getAnalytics,
  setAnalyticsCollectionEnabled,
  isSupported,
} from "firebase/analytics";

let firebaseConfig = {};

if (process.env.REACT_APP_USE_LOCAL_DB === "true") {
  // local
  firebaseConfig = {
    apiKey: "AIzaSyCxyzIpi7a4hW7nA6vC1esMDrlmGYworZU",
    authDomain: "grooming-app-local.firebaseapp.com",
    projectId: "grooming-app-local",
    storageBucket: "grooming-app-local.firebasestorage.app",
    messagingSenderId: "490389993121",
    appId: "1:490389993121:web:44481f7fe283893975e2e0",
    measurementId: "G-B8YKS7TVW6",
  };
} else {
  // prod
  firebaseConfig = {
    apiKey: "AIzaSyBKI3YsGX8c2nPqH1hlHfp2A9mt9kVf5nM",
    authDomain: "grooming-app-96905.firebaseapp.com",
    projectId: "grooming-app-96905",
    storageBucket: "grooming-app-96905.firebasestorage.app",
    messagingSenderId: "354756706861",
    appId: "1:354756706861:web:eff01aec989a71b9762ea4",
    measurementId: "G-CQRZ6RBP4M",
  };
}

const app = initializeApp(firebaseConfig);

/**
 * Firestore with an on-disk (IndexedDB) cache.
 *
 * Without this the SDK keeps everything in memory only, so every page refresh
 * re-downloads the account's whole working set before anything renders — for a
 * busy salon that is thousands of appointment documents on each load, which is
 * why a refresh could sit for ~20 seconds. With the persistent cache the reload
 * paints from disk and the network only carries what actually changed.
 *
 * `persistentMultipleTabManager` keeps it correct when the groomer has the
 * dashboard open in more than one tab. Some environments (Safari private
 * browsing, storage disabled) can't open IndexedDB at all, so fall back to the
 * in-memory default rather than leaving the app without a database.
 */
function createFirestore() {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    });
  } catch (err) {
    console.warn(
      "[firebase] Persistent Firestore cache unavailable, using memory cache:",
      err?.message || err,
    );
    return getFirestore(app);
  }
}

// Core Firebase services
export const auth = getAuth(app);
export const db = createFirestore();
export const storage = getStorage(app);

// Analytics
let analytics;
if (typeof window !== "undefined") {
  isSupported()
    .then((supported) => {
      if (!supported) return;
      analytics = getAnalytics(app);

      // 🚫 If cookie is present, disable analytics on this browser
      const noAnalytics = document.cookie.includes("no_analytics=1");
      setAnalyticsCollectionEnabled(analytics, !noAnalytics);
    })
    .catch(() => {
      // Ignore analytics setup failures in unsupported environments.
    });

  // // (Optional) Quick console hint
  // console.info(
  //   noAnalytics
  //     ? "🔕 Analytics disabled for this browser (no_analytics=1)."
  //     : "🔔 Analytics enabled for this browser."
  // );
}

export { analytics };
export default app;
